import { useEffect, useState } from 'react'
import { View, Text, TouchableOpacity, StyleSheet, ActivityIndicator } from 'react-native'
import { useTranslation } from 'react-i18next'
import { useRouter } from 'expo-router'
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons'
import { useAuth } from '../lib/AuthContext'
import { supabase } from '../lib/supabase'
import { COMPETITIONS } from '../lib/competitions'
import { fonts } from '../lib/theme'

// Competizione attiva senza nessuna lega dell'utente (la prima volta che apre "Donne", o dopo essere uscito da tutte).
// Offre l'ingresso nella lega ufficiale della competizione (la prima lega pubblica di quella competizione) e il passaggio
// alla scheda Leghe. Stesso schema di VB (components/NoLeagueState.jsx).
export default function NoLeagueState({ tc, inline = false }) {
  const { t } = useTranslation()
  const router = useRouter()
  const { user, competitionId, refreshLeagues, switchLeague } = useAuth()
  const [official, setOfficial] = useState(null)   // { id_league, name } | null: nessuna lega ufficiale trovata
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState('')

  const comp = COMPETITIONS.find((c) => c.id === competitionId)

  useEffect(() => {
    let alive = true
    setOfficial(null)
    supabase.from('dim_league').select('id_league, name').eq('id_competition', competitionId).eq('is_public', true).order('id_league').limit(1)
      .then(({ data }) => { if (alive) setOfficial(data?.[0] ?? null) })
    return () => { alive = false }
  }, [competitionId])

  const join = async () => {
    if (!official) return
    setBusy(true); setErr('')
    const { data, error } = await supabase.rpc('fn_join_league', { p_id_user: user?.id, p_id_league: official.id_league, p_password: null })
    if (error || data?.error) {
      setErr(error?.message ?? data.error)
      setBusy(false)
      return
    }
    await refreshLeagues?.()
    await switchLeague?.({ id_league: official.id_league, name: official.name })
    setBusy(false)
  }

  return (
    <View style={[styles.wrap, inline ? styles.inline : styles.full, { backgroundColor: inline ? tc.bgCard2 : tc.bg, borderColor: tc.border }]}>
      <MaterialCommunityIcons name="bike" size={32} color={tc.textDim} />
      <Text style={[styles.title, { color: tc.text }]}>{t('no_league.title', { comp: comp ? t(comp.labelKey) : '' })}</Text>
      <Text style={[styles.body, { color: tc.textMuted }]}>{official ? t('no_league.body_official') : t('no_league.body')}</Text>

      {official && (
        <TouchableOpacity style={[styles.btn, { backgroundColor: tc.rosa, opacity: busy ? 0.6 : 1 }]} onPress={join} disabled={busy}>
          {busy
            ? <ActivityIndicator color={tc.brandText} />
            : <Text style={[styles.btnText, { color: tc.brandText }]}>{t('no_league.join', { name: official.name })}</Text>}
        </TouchableOpacity>
      )}
      {!inline && (
        <TouchableOpacity style={[styles.btn, styles.btnGhost, { borderColor: tc.border }]} onPress={() => router.push('/leagues')}>
          <Text style={[styles.btnText, { color: tc.text }]}>{t('no_league.go_leagues')}</Text>
        </TouchableOpacity>
      )}
      {err ? <Text style={[styles.body, { color: '#ef4444' }]}>{err}</Text> : null}
    </View>
  )
}

const styles = StyleSheet.create({
  wrap: { alignItems: 'center', gap: 10, padding: 24 },
  full: { flex: 1, justifyContent: 'center' },
  inline: { borderWidth: 1, borderRadius: 14, marginTop: 8, marginBottom: 20 },
  title: { fontFamily: fonts.condensedBold, fontSize: 20, fontWeight: '800', textAlign: 'center' },
  body: { fontSize: 13, lineHeight: 19, textAlign: 'center', maxWidth: 340 },
  btn: { borderRadius: 12, paddingVertical: 12, paddingHorizontal: 20, minWidth: 220, alignItems: 'center', marginTop: 4 },
  btnGhost: { borderWidth: 1, backgroundColor: 'transparent' },
  btnText: { fontFamily: fonts.condensedBold, fontSize: 15, fontWeight: '800' },
})
